var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.type)?_c('div',{staticClass:"preview-backtop",on:{"click":_vm.goToTop}},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):_c('img',{attrs:{"src":require("../../images/back2x.png"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }